"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BetaBanner;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BetaBanner() {
  return _react2.default.createElement(
    "section",
    { className: "BetaBanner" },
    _react2.default.createElement(
      "div",
      { className: "container" },
      _react2.default.createElement(
        "strong",
        null,
        "Version b\xEAta!"
      ),
      " On veut vos commentaires\xA0: ",
      _react2.default.createElement(
        "a",
        { href: "mailto:beta@caligram.com" },
        "beta@caligram.com"
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BetaBanner.js
// module id = 1072
// module chunks = 0